import { IconAlertTriangle } from '@tabler/icons-react';
import { EmailLevel, KYCLevel, User } from '@xver/@types/user';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

interface CouponEligibilityNoticeProps {
    user: User | undefined;
}

export default function CouponEligibilityNotice({ user }: CouponEligibilityNoticeProps) {
    const { t } = useTranslation('coupon');
    if (!user) return null;

    const issues: { key: string; node: React.ReactNode }[] = [];

    if (user.kyc?.level === KYCLevel.L0) {
        issues.push({
            key: 'kyc',
            node: (
                <span>
                    {t('eligibility.kyc')}{' '}
                    <Link to="/account/profile" className="underline">
                        Profile
                    </Link>
                </span>
            ),
        });
    }

    if (user.verifyEmailAddress !== EmailLevel.E2) {
        issues.push({
            key: 'email',
            node: (
                <span>
                    {t('eligibility.email')}{' '}
                    <Link to="/account/security" className="underline">
                        Security
                    </Link>
                </span>
            ),
        });
    }

    if (user.status && user.status !== 'active') {
        issues.push({
            key: 'status',
            node: <span>{t('eligibility.status', { status: user.status })}</span>,
        });
    }

    if (issues.length === 0) return null;

    return (
        <div className="w-full p-4 flex flex-row gap-3 rounded-md border-[0.5px] border-[#5e4a14] bg-[#3a2e0a] text-yellow-200 light:bg-amber-100 light:border-amber-300 light:text-amber-900">
            <IconAlertTriangle size={22} stroke={1.5} className="shrink-0" />
            <div className="flex flex-col gap-1">
                <h3 className="text-sm font-bold">{t('eligibility.title')}</h3>
                <ul className="text-sm list-disc list-inside flex flex-col gap-1">
                    {issues.map((issue) => (
                        <li key={issue.key}>{issue.node}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
